enum NEW_STREAMING_DESTINATION_TYPE_SELECTOR_VARIANT {
  TILE = 'tile',
  LIST = 'list',
}

export {
  NEW_STREAMING_DESTINATION_TYPE_SELECTOR_VARIANT,
};
